// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"caa918f6","216":"c61c82ab","727":"2fcc9cec"}[chunkId] + ".chunk.css";
};